import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const LINKS = [
    { label: "STORY", href: "#story" },
    { label: "TEASER", href: "#teaser" },
    { label: "CAST", href: "#cast" },
    { label: "SEASON", href: "#season" },
    { label: "AUDIENCE", href: "#audience" },
    { label: "THE SAGA", href: "#saga" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const go = (href) => {
        setOpen(false);
        scrollToId(href);
    };

    return (
        <header
            data-testid="site-header"
            className="fixed top-0 inset-x-0 z-[80] border-b border-white/10 bg-black/70 backdrop-blur-xl"
        >
            <div className="mx-auto flex max-w-[1500px] items-center justify-between px-5 sm:px-8 h-16">
                <a
                    href="#top"
                    data-testid="nav-logo"
                    onClick={(e) => {
                        e.preventDefault();
                        go("#top");
                    }}
                    className="flex items-center group"
                >
                    <span className="flex flex-col leading-none">
                        <span className="font-display text-base tracking-[0.18em] text-white group-hover:text-[#d6c68e] transition-colors duration-300">
                            DEADLY AMBITION
                        </span>
                        <span className="mt-1 font-mono text-[9px] tracking-[0.3em] text-zinc-500">
                            CELESTIAL LIGHT ORIGINALS
                        </span>
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-7" data-testid="nav-desktop">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={(e) => {
                                e.preventDefault();
                                go(l.href);
                            }}
                            className="font-mono text-[11px] tracking-[0.22em] text-zinc-400 hover:text-white transition-colors duration-300"
                        >
                            {l.label}
                        </a>
                    ))}
                    <button
                        data-testid="nav-request-deck-btn"
                        onClick={() => go("#contact")}
                        className="ml-2 border border-[#d6c68e] px-5 py-2 font-mono text-[11px] tracking-[0.22em] text-white transition-all duration-300 hover:bg-[#d6c68e] hover:text-[#04060d] hover:shadow-[0_0_28px_rgba(214,198,142,0.45)]"
                    >
                        REQUEST THE DECK
                    </button>
                </nav>

                <button
                    data-testid="nav-mobile-toggle"
                    aria-label="Toggle menu"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden text-white p-2"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        data-testid="nav-mobile"
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="lg:hidden overflow-hidden border-t border-white/10 bg-black/95"
                    >
                        <div className="flex flex-col px-6 py-6 gap-5">
                            {LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        go(l.href);
                                    }}
                                    className="font-mono text-xs tracking-[0.25em] text-zinc-300 hover:text-[#d6c68e] transition-colors"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <button
                                data-testid="nav-mobile-request-deck-btn"
                                onClick={() => go("#contact")}
                                className="mt-2 border border-[#d6c68e] px-5 py-3 font-mono text-xs tracking-[0.22em] text-white hover:bg-[#d6c68e] hover:text-[#04060d] transition-colors"
                            >
                                REQUEST THE DECK
                            </button>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
};
